import { gsap } from 'gsap';

export default () => {
  const overlays = [...document.querySelectorAll('.availability-overlay')];

  const openOverlay = (data) => {
    const overlay = overlays.find(item => item.dataset.floor === data);
    if (!overlay) {
      return;
    }

    overlay.classList.add('availability-overlay--open');
    document.body.style.overflow = 'hidden';
  }

  const initListHover = () => {
    const buttons = [...document.querySelectorAll('.to-row')];

    if (!buttons || buttons.length === 0) {
      return;
    }

    buttons.forEach(button => {
      const data = button.dataset.hover;

      if (!data) {
        return;
      }

      const hoveredRect = document.querySelector(`#building-${data}`);

      if(!hoveredRect) {
        return
      }

      hoveredRect.style.opacity = 0

      button.addEventListener('mouseover', () => {
        hoveredRect.style.opacity = 1;
      })

      button.addEventListener('mouseleave', () => {
        hoveredRect.style.opacity = 0;
      })

      button.addEventListener('click', () => {
        openOverlay(data);
      })
    })
  }

  const initBuildingHover = () => {
    const elements = [...document.querySelectorAll('.building-hovered-el')];
    const buttons = [...document.querySelectorAll('[data-hover]')]

    if (!elements || elements.length === 0) {
      return;
    }

    elements.forEach(element => {
      const id = element.id.split('-')[1];

      const button = buttons.find(btn => btn.dataset.hover === id);

      element.addEventListener('mouseover', () => {
        button.classList.add('to-row--hovered')
        element.style.opacity = 1;
      })

      element.addEventListener('mouseleave', () => {
        button.classList.remove('to-row--hovered')
        element.style.opacity = 0;
      })

      element.addEventListener('click', () => {
        openOverlay(id);
      })
    })
  }

  const initOverlay = () => {
    overlays.forEach(overlay => {
      const close = overlay.querySelector('.availability-overlay__close-btn');
      close.addEventListener('click', () => {
        overlay.classList.remove('availability-overlay--open');
        document.body.style.overflow = '';
      });
    });
  };

  const initTabs = () => {
    overlays.forEach(overlay => {
      const tabButtons = [...overlay.querySelectorAll('.tab')];
      const tabsContent = [...overlay.querySelectorAll('.tab-content')]
      const tabsContentRight = [...overlay.querySelectorAll('.tab-content-right')]
      if (
        !tabButtons || tabButtons.length === 0 ||
        !tabsContent || tabsContent.length === 0 ||
        !tabsContentRight || tabsContentRight.length === 0
      ) {
        return;
      }

      const cleanActiveClasses = () => {
        tabButtons.forEach(tab => tab.classList.remove('tab--active'))
        tabsContent.forEach(tab => tab.classList.remove('tab-content--active'))
        tabsContentRight.forEach(tab => tab.classList.remove('tab-content-right--active'))
      }

      tabButtons.forEach(tabBtn => {
        const tabData = tabBtn.dataset.tab;

        if (!tabData) {
          return;
        }

        tabBtn.addEventListener('click', () => {
          const content = tabsContent.find(content => content.dataset.tab === tabData);
          const contentRight = tabsContentRight.find(content => content.dataset.tab === tabData);
          const galleryContainer = overlay.querySelector('.gallery-container');
          
          if (tabData === 'floorplans' || tabData === 'spaceplans') {
            cleanActiveClasses(tabData);
            tabBtn.classList.add('tab--active');
            if(content) {
              content.classList.add('tab-content--active');
            }
            if(contentRight) {
              contentRight.classList.add('tab-content-right--active');
            }
            const container = overlay.querySelector('.container');
            container.style.display ='block';
            if(galleryContainer) {
              galleryContainer.classList.remove('gallery-container--active');
            }
          } else if (tabData === 'gallery') {
            const container = overlay.querySelector('.container');
            container.style.display = 'none';
            cleanActiveClasses(tabData);

            galleryContainer.classList.add('gallery-container--active');
            const galleryTab = galleryContainer.querySelector('[data-tab="gallery"]');
            galleryTab.classList.add('tab--active');

            const button = overlay.querySelector('.gallery-btn');

            if(!button) {
              return;
            }

            button.addEventListener('click', () => {
              const overlayHeight = overlay.clientHeight;

              gsap.to(overlay, {
                duration: 1,
                ease: "power2.out",
                scrollTo: {
                  y: overlayHeight,
                }
              });
            })
          }
        })
      })
    })
  }


  initListHover();
  initBuildingHover();
  initOverlay();
  initTabs();
}